import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateGroupMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.CreateGroupInput;
}>;


export type CreateGroupMutation = (
  { __typename: 'Mutation' }
  & { createGroup: (
    { __typename: 'CreateGroupSuccessfulResponse' }
    & { result: (
      { __typename: 'Group' }
      & GroupItemDataFragment
    ) }
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);

export type GroupItemDataFragment = (
  { __typename: 'Group' }
  & Pick<SchemaTypes.Group, 'id' | 'name' | 'description' | 'companyId'>
);

export const GroupItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment GroupItemData on Group {
  id
  name
  description
  companyId
}
    `;
export const CreateGroupDocument = /*#__PURE__*/ gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    __typename
    ... on CreateGroupSuccessfulResponse {
      result {
        ...GroupItemData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${GroupItemDataFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;